'use strict';
namespace TR {
    angular
        .module('TR')
        .constant('hotelCriteria', [
            {val: [1], name: 'RECOMMENDED'},
            {val: [5, 6], name: 'PRICE', defaultSort: 5, defaultOrder: 'asc'},
            {val: [8, 7], name: 'STARRATING', defaultSort: 8, defaultOrder: 'desc'}
        ])
        .constant('flightCriteria', [
            {val: [10], name: 'RECOMMENDEDFLIGHT', oneWay: true},
            {val: [1, 2], name: 'PRICE', oneWay: true, defaultSort: 1, defaultOrder: 'asc'},
            {
                val: [4, 5],
                name: 'DEPARTURETIME',
                oneWay: true,
                defaultSort: 4,
                defaultOrder: 'asc',
                ascSuffix: 'SORTDIRECTIONTIMELABELASCENDING',
                descSuffix: 'SORTDIRECTIONTIMELABELDESCENDING'
            },
            {
                val: [6, 7],
                name: 'RETURNTIME',
                oneWay: false,
                defaultSort: 6,
                defaultOrder: 'asc',
                ascSuffix: 'SORTDIRECTIONTIMELABELASCENDING',
                descSuffix: 'SORTDIRECTIONTIMELABELDESCENDING'
            },
            {val: [9, 8], oneWay: true, name: 'TOTALJOURNEYTIME', defaultSort: 9, defaultOrder: 'asc'}
        ])
        .constant('dealsCriteria', [
            {val: [1], name: 'RECOMMENDED', qs: 'rc'},
            {val: [5, 6], name: 'PRICE', defaultSort: 5, defaultOrder: 'asc'},
            {val: [8, 7], name: 'STARRATING', defaultSort: 8, defaultOrder: 'desc'}
        ])
        .constant('costBreakdownCodes', {
            Hotel: 1,
            CancellationProtection: 21,
        });

}
